/** Способ создания черновика: подача декларации с целью получения вычета за лечение */
export const DRAFT_MODE = 3;
export const STEP_DEDUCTION = 'deductions';
export const STEP_DEDUCTION_FORM = `${STEP_DEDUCTION}Form`;
